import {
  addCategory,
  addColor,
  addCondition,
  addLocation,
  addMminimumOrder,
  addNavCategory,
  addPrice,
  removeCategory,
  removeColor,
  removePrice,
} from "../../REDUX/ProductFilter/ProductFilter";

/* writing out this function so it can be called anywhere  */

/* color */
export const handleChangeColor = (e, dispatch) => {
  const { value, checked } = e.target;

  if (checked) {
    dispatch(addColor(value));
  } else {
    dispatch(removeColor(value));
  }
};

/* price */
export const handleChangePrice = (e, dispatch) => {
  const { value, checked } = e.target;

  if (checked) {
    dispatch(addPrice(value));
  } else {
    dispatch(removePrice(value));
  }
};

/* range */
export function handleChangeRange(e, dispatch) {
  dispatch(addMminimumOrder(e.target.value));
}

/* location */
export function handleChangeLocation(e, dispatch) {
  dispatch(addLocation(e.target.innerHTML));
}

/* condition */
export function handleChangeCondition(e, dispatch) {
  dispatch(addCondition(e.target.value));
}

/* category */
export const handleChangeCategory = (e, dispatch, category) => {
  const value = e.target.textContent;
  if (category.includes(value)) {
    dispatch(removeCategory(value));
    return;
  } else {
    dispatch(addCategory(value));
  }
};

export function ChoooseNavCategory(e, dispatch) {
  dispatch(addNavCategory(e.currentTarget.innerHTML));
}
